<template>
  <div v-if="displayFilter">
    <el-select
        class="w-100"
        remote
        :multiple="multiple"
        :clearable="clearable"
        :value="value"
        :placeholder="placeholders"
        :filterable="filterable"
        :remote-method="searchOptions"
        :reserve-keyword="reserveKeyword"
        @change="onChange"
    >
      <el-option
          v-for="option in found"
          :key="option[optionKey]"
          :label="option[optionLabel]"
          :value="option[optionValue]">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import BaseFilter from "./base-select-filter";
import {isBlank} from "../../../../helpers";

export default {
  extends: BaseFilter,

  props: {
    url: String,
    filterable: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    cached: [],
    found: [],
  }),

  computed: {
    /**
     * @return {Array}
     */
    allOptions() {
      return _.unionBy(this.found, this.cached, this.extractValue);
    },
  },

  watch: {
    options: {
      handler(value) {
        this.cached = [];
        this.found = _.map(value, this.formatOption);
      },
      immediate: true,
    },
  },

  methods: {
    /**
     * @return {Object}
     */
    getOptionBy(value) {
      return _.find(this.allOptions, {[this.optionValue]: value});
    },

    /**
     * @param {*} newVal
     * @param {*} oldVal
     */
    onValueChange(newVal, oldVal) {
      this.updateLabels(newVal);
      this.rebuildCache(newVal);
    },

    /**
     * @param {*} value
     */
    rebuildCache(value) {
      this.cached = this.canCacheValue(value)
          ? this.filterOptionsBy(this.cached, _.castArray(value))
          : [];
    },

    /**
     * @return {boolean}
     */
    canCacheValue(value) {
      return !isBlank(value);
    },

    /**
     * @param {string} search
     */
    searchOptions(search) {
      axios.get(this.url, this.getRequestConfig(search))
          .then(({data}) => this.onSearchOptionsSuccess(data))
          .catch(err => {
            this.$message.error('Whoops. It looks like the server is unavailable.');
          });
    },

    /**
     * @param {Array} data
     */
    onSearchOptionsSuccess({data}) {
      const formatted = _.map(data, this.formatOption);
      this.cacheOptions(formatted);
      this.found = formatted;
    },

    /**
     * @param {Array} formatted
     */
    cacheOptions(formatted) {
      if (!this.canCacheValue(this.value)) {
        return;
      }

      const requireCaching = _.difference(
          _.values(_.castArray(this.value)),
          _.map(formatted, this.extractValue)
      );

      this.cached = this.filterOptionsBy(this.allOptions, requireCaching);
    },

    /**
     * @param {Object} item
     * @return {*}
     */
    extractValue(item) {
      return _.get(item, this.optionValue);
    },

    /**
     * @param {Array} options
     * @param {Array} values
     * @return {Array}
     */
    filterOptionsBy(options, values) {
      return _.filter(options, option => {
        return _.includes(values, this.extractValue(option));
      });
    },

    /**
     * @param {string} search
     * @return {Object}
     */
    getRequestConfig(search) {
      return {params: {search}};
    },

    /**
     * @param {Object} option
     * @return {Object}
     */
    formatOption(option) {
      return option;
    },
  },
}
</script>
